import { render, staticRenderFns } from "./IrisDisplayInputFieldVariable.vue?vue&type=template&id=481427a6&"
import script from "./IrisDisplayInputFieldVariable.vue?vue&type=script&lang=ts&"
export * from "./IrisDisplayInputFieldVariable.vue?vue&type=script&lang=ts&"
import style0 from "./IrisDisplayInputFieldVariable.vue?vue&type=style&index=0&id=481427a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports